module.exports = __webpack_public_path__ + "img/4.b4b788f1.png";